



























import { Component, Prop, Vue } from 'vue-property-decorator';
import {UserProfile} from "../../../../../api/models/UserProfile";
import TagList from "../../../../../share/common/tag-list/TagList.vue";

@Component({
    name: 'InterestsPart',
    components: { TagList }
})
export default class InterestsPart extends Vue {
    @Prop({required: true}) profile: UserProfile;
    @Prop({required: true}) tags: object[];
    @Prop({required: true}) validationMessages: Record<string, string>;

    tagsFielsets: any[] = [];

    activated() {
        this.init()
    }

    mounted() {
        this.init()
    }

    init() {

        this.tagsFielsets = [
            { label: this.$t('settings.lookingFor'), key: 'looking', items:[] },
            { label: this.$t('settings.offer'), key: 'offer', items:[] },
        ];

        //TODO: change to deep copy
        this.tagsFielsets.forEach(set => set.items = JSON.parse(JSON.stringify(this.tags)));

        if(this.profile.tagsIds || this.profile.interestingTagIds) {
            this.setExistingValues(this.profile.tagsIds || [], this.profile.interestingTagIds || [])
        }
        else {
            this.setVals();
        }

        this.$emit('validate', false);
    }

    setFieldVals(key: string) {
        const res: any[] = [];

        const field = this.tagsFielsets.find(item => item.key === key);
        field?.items?.filter((item: any) => item?.isSelected).forEach((item: any) => res.push(item?.tag?.id) );
        return res;
    }

    setExistingValues(tagsIds: string[], interestingTagIds: string[]) {
        this.tagsFielsets.forEach((fieldSet) => {
            if(fieldSet.key === "looking") {
                interestingTagIds.forEach((interestingTagId) => {

                    fieldSet.items.forEach((fieldSetItem: any) => {
                        if(fieldSetItem.tag.id === interestingTagId) {
                            fieldSetItem.isSelected = true
                        }
                    })
                })
            }

            if(fieldSet.key === "offer") {
                tagsIds.forEach((tagId) => {

                    fieldSet.items.forEach((fieldSetItem: any) => {
                        if(fieldSetItem.tag.id === tagId) {
                            fieldSetItem.isSelected = true
                        }
                    })
                })
            }
        })
    }

    setVals() {
        this.profile.tagsIds = this.setFieldVals('offer');
        this.profile.interestingTagIds = this.setFieldVals('looking');
    }

    onSelectTag($event: any) {
        $event.isSelected = !$event.isSelected;
        this.setVals();
        this.$emit('validate');
    }
}
